<template>
  <span v-if="labelItems?.length > 0">
    <template v-for="(labelItem, labelIndex) in labelItems" >
      <template v-if="labelItem.labelDescription">
        <a-tooltip :key="labelIndex">
          <template slot="title">
            <pre style="white-space: pre-line; margin: 0;">{{ labelItem.labelDescription }}</pre>
          </template>
          <img class="boutique-airline-icon" :src="labelItem.labelImg" />
        </a-tooltip>
      </template>
      <template v-else>
        <img :key="labelIndex" class="boutique-airline-icon" :src="labelItem.labelImg" />
      </template>
    </template>
  </span>
</template>

<script>
import { MINIO_FRONTEND_STATIC_ROUTE } from '@/assets/js/util'
// import PremiumRoutes from '@/pages/flight-search/image/flight-search-label/PremiumRoutes.png'
// import TravelRoutes from '@/pages/flight-search/image/flight-search-label/TravelRoutes.png'
// import WildHorseRoutes from '@/pages/flight-search/image/flight-search-label/WildHorseRoutes.png'
// import { labelIcon } from '@/pages/flight-search/image/flight-search-label/'
// const labelIcons = {
//   PremiumRoutes: require('@/pages/flight-search/image/flight-search-label/PremiumRoutes.png'),
//   TravelRoutes: require('@/pages/flight-search/image/flight-search-label/TravelRoutes.png'),
//   WildHorseRoutes: require('@/pages/flight-search/image/flight-search-label/WildHorseRoutes.png')
// }
export default {
  props: {
    flightItem: Object,
    boutiqueAirlineLabels: Array
  },
  computed: {
    // 是否展示精品航线
    labelItems () {
      const { flightItem = {}, boutiqueAirlineLabels = [] } = this
      if (boutiqueAirlineLabels?.length === 0) {
        return
      }
      const { departureCode, arrivalCode, airlineCode, departureDate } = flightItem

      function matchCode (flightCode, labelCode) {
        // 将模式字符串中的 '*' 转换为适合正则表达式的 '.*'
        const regexPattern = labelCode.replace(/\*/g, '.*')
        // 创建 RegExp 对象，'^' 匹配输入字符串的开始位置，'$' 匹配输入字符串的结束位置
        const regex = new RegExp('^' + regexPattern + '$', 'i') // 'i' 使匹配不区分大小写
        return regex.test(flightCode)
      }

      let seenValues = {}
      const labelItems = boutiqueAirlineLabels
        .filter(labelItem => {
          // 正则表达式匹配出发地和目的地编码
          const isDepartureMatched = matchCode(departureCode, labelItem.originCode)
          const isArrivalMatched = matchCode(arrivalCode, labelItem.destinationCode)
          const labelAirlineCode = labelItem.airlineCode
          const { labelStartDate, labelEndDate } = labelItem
          const [startDate, endDate, now] = [new Date(labelStartDate)?.getTime(), new Date(labelEndDate)?.getTime(), new Date(departureDate)?.getTime()]
          return (airlineCode === labelAirlineCode || labelAirlineCode.includes(airlineCode) || labelAirlineCode.includes('ALL')) && // 航司代码条件，支持互售航司打标
                 isDepartureMatched && // 出发地匹配
                 isArrivalMatched && // 目的地匹配
                 ((startDate <= now && now <= endDate) || (startDate <= now && !endDate) || (now <= endDate && !startDate) || (!startDate && !endDate)) // 时间区间条件
        }).filter(item => {
          // 去重
          const value = item.labelType
          if (seenValues[value]) {
            return false
          }
          seenValues[value] = true
          return true
        }).map(labelItem => {
          // let labelImg = labelIcons[labelItem?.labelType]
          const labelImg = `${MINIO_FRONTEND_STATIC_ROUTE}/flight-search-label/${labelItem?.labelType}.png`
          return { ...labelItem, labelImg }
        })

      return labelItems
    }
  }
}
</script>
